import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass({
      'vp-input-container': true,
      'text-right': true,
    })
}
const _hoisted_2 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_text = _resolveComponent("input-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass({ 'p-float-label': true, 'vp-invalid': _ctx.inputVal.$error })
    }, [
      _createVNode(_component_input_text, {
        disabled: _ctx.disabled,
        autocomplete: _ctx.name,
        class: _normalizeClass({ 'p-invalid': _ctx.inputVal.$error }),
        name: _ctx.name,
        modelValue: _ctx.inputVal.$model,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputVal.$model) = $event)),
        onChange: _ctx.updateValue
      }, null, 8, ["disabled", "autocomplete", "class", "name", "modelValue", "onChange"]),
      _createElementVNode("label", {
        class: _normalizeClass({ 'vp-variant': _ctx.disabled }),
        for: _ctx.name
      }, _toDisplayString(_ctx.$t(_ctx.title)), 11, _hoisted_2)
    ], 2),
    _createElementVNode("small", {
      class: _normalizeClass({
        hidden: !_ctx.showInfo || (!_ctx.showInfo && _ctx.inputVal.$dirty),
        'vp-notice text-right': true,
      })
    }, _toDisplayString(_ctx.info), 3),
    _createElementVNode("small", {
      class: _normalizeClass({ hidden: !_ctx.inputVal.$error, 'vp-notice p-error': true })
    }, _toDisplayString(_ctx.showError()), 3)
  ]))
}